__turbopack_context__.v({
  "arrow": "VisiblyScrollable-module__-7YdEa__arrow",
  "indicator": "VisiblyScrollable-module__-7YdEa__indicator",
  "indicatorBottom": "VisiblyScrollable-module__-7YdEa__indicatorBottom",
  "indicatorTop": "VisiblyScrollable-module__-7YdEa__indicatorTop",
  "inner": "VisiblyScrollable-module__-7YdEa__inner",
  "mobileContentInset": "VisiblyScrollable-module__-7YdEa__mobileContentInset",
  "mobileExpandable": "VisiblyScrollable-module__-7YdEa__mobileExpandable",
  "mobileExpanded": "VisiblyScrollable-module__-7YdEa__mobileExpanded",
  "mobileReadMoreFooter": "VisiblyScrollable-module__-7YdEa__mobileReadMoreFooter",
  "mobileReadMoreOverlay": "VisiblyScrollable-module__-7YdEa__mobileReadMoreOverlay",
  "readLessButton": "VisiblyScrollable-module__-7YdEa__readLessButton",
  "readMoreButton": "VisiblyScrollable-module__-7YdEa__readMoreButton",
  "root": "VisiblyScrollable-module__-7YdEa__root",
  "vs-arrow-breathe": "VisiblyScrollable-module__-7YdEa__vs-arrow-breathe",
});
